import styled from "@emotion/styled";
import React from "react";
import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";
import { Flex } from "../grid";
import { InputLabel } from "../typography";

const Step = styled.div((props: { isActive: boolean }) => ({
  backgroundColor: props.isActive ? colors.success : colors.primary,
  height: '4px',
  borderRadius: '4px',
  width: '100%',
}))

export type StepperProps = MergeWithOverwrite<React.HTMLAttributes<HTMLDivElement>, {
  currentStep: number;
  totalSteps: number;
  showLabel?: boolean;
}>;

export const Stepper = ({ currentStep, totalSteps, showLabel = true }: StepperProps) => (
  <Flex vertical gap={4}>
    {showLabel && <InputLabel color={colors.success}>Korak {currentStep} od {totalSteps}</InputLabel>}
    <Flex gap={4}>
      {[...Array(totalSteps)].map((_, index) => (
        <Step key={index} isActive={index + 1 <= currentStep} />
      ))}
    </Flex>
  </Flex>
);
